import styled from 'styled-components';

export const HeaderWrapper = styled.div`
    position: fixed;
    top: 0;
    width: 98%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 0;
    margin-right: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: ${props => props.theme.voltBlue};
    height: ${props => props.minimize ? '50px' : '100px'};

    @media only screen and (max-width: 700px) {
        height: 100px;
    }
`;

export const TopButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: space-between;

    &:hover {
        cursor: pointer;
    }
    @media only screen and (max-width: 700px) {
        flex-direction: column;
        height: 100%;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
    }
`; 

export const SubmitButton = styled.button`
    background-color: ${props => props.theme.evTeal};
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 200px;
    height: 40px;
    align-self: left;
    font-size: 1rem;
    margin-right: 20px;

    &:hover {
        background-color: ${props => props.theme.eLime};
    }
    
    &:disabled {
        background-color: #b3b3b3;
        cursor: not-allowed;
    }
    
    @media only screen and (max-width: 700px) {
        font-size: 0.8rem;
        height: 20px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
`;

export const Logo = styled.img`
    height: auto;
    padding: 1rem;
    width: ${props => props.minimize ? '31px' : '60px'};

    @media only screen and (max-width: 700px) {
        width: 60px;
    }

`;
